import { render, staticRenderFns } from "./createGateway.vue?vue&type=template&id=42295278&scoped=true&"
import script from "./createGateway.vue?vue&type=script&lang=js&"
export * from "./createGateway.vue?vue&type=script&lang=js&"
import style0 from "./createGateway.vue?vue&type=style&index=0&id=42295278&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42295278",
  null
  
)

export default component.exports